export const getNotificationsFilter = () => {
    const notificationsFilter = sessionStorage.getItem('notificationsFilter') ?? 'null'
    const notificationsFilterByProducts: string[] = JSON.parse(notificationsFilter) ?? []
    return notificationsFilterByProducts
}
